import { render } from "./MooveTerms.vue?vue&type=template&id=aaa21d2e&ts=true"
import script from "./MooveTerms.vue?vue&type=script&lang=ts"
export * from "./MooveTerms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__